<template>

  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Mostrando</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="pageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
          <!-- <b-button
            variant="primary"
          >
            Exportar
          </b-button> -->
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="query"
              class="d-inline-block mr-1"
              placeholder="Search..."
            />
            <flat-pickr
              id="fecha"
              v-model="fechaFilter"
              class="form-control"
              :config="configDP"
              placeholder="Seleccione Fecha"
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="refListTable"
      :items="items"
      responsive
      :fields="fields"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      empty-text="No se encontraron registros"
      class="position-relative"
      :busy="isBusy"
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner
            variant="primary"
            class="align-middle"
          />
          <strong class="ml-1">Cargando...</strong>
        </div>
      </template>

      <!-- Column: Individuo -->
      <template #cell(nombres)="data">
        <b-media vertical-align="center">
          <span class="font-weight-bolder d-block text-nowrap font-small-3">
            {{ data.item.nombres }}
          </span>
        </b-media>
      </template>

      <template #cell(email)="data">
        <div class="d-flex align-items-center">
          <div>
            <div class="font-small-3">
              <feather-icon icon="MailIcon" />
              {{ data.item.email }}
            </div>
            <div class="font-small-3">
              <feather-icon icon="PhoneIcon" />
              {{ data.item.celular }}
            </div>
          </div>
        </div>
      </template>

      <template #cell(asunto)="data">
        <div class="align-items-center">
          <div>
            <b-badge
              pill
              variant="light-success"
            >
              {{ data.item.asunto }}
            </b-badge>
          </div>
          <div class="font-small-3 text-justify">
            {{ data.item.mensaje }}
          </div>
        </div>
      </template>

      <template #cell(fechaRegistro)="data">
        <div class="font-small-3 text-justify">
          <b>Registro:</b> {{ formatDateTime(data.item.fechaRegistro) }}
        </div>
        <div
          v-if="data.item.fechaAtencion"
          class="font-small-3 text-justify"
        >
          <b>Atención:</b> {{ formatDateTime(data.item.fechaAtencion) }}
        </div>
      </template>

      <template #cell(estadoAtencion)="data">
        <div class="align-items-center">
          <div>
            <b-badge
              pill
              :variant="`light-${data.item.estadoAtencion === 'PENDIENTE' ? 'warning' : 'success'}`"
            >
              {{ data.item.estadoAtencion }}
            </b-badge>
          </div>
        </div>
      </template>

      <template #cell(acciones)="data">
        <b-button-toolbar justify>
          <b-button-group size="sm">
            <b-button
              v-if="data.item.estadoAtencion === 'PENDIENTE'"
              v-b-tooltip.hover.top="'Actualizar a Atendido'"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="success"
              @click="updateStatus(data.item)"
            >
              <feather-icon icon="ThumbsUpIcon" />
            </b-button>
          </b-button-group>
        </b-button-toolbar>
      </template>

    </b-table>
    <div class="mx-2 mb-2">
      <b-row>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing {{ from }} a {{ to }} de {{ of }} registros</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="page"
            :total-rows="totalItems"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </b-card>

</template>

<script>
import Vue from 'vue'
import { ref, watch } from '@vue/composition-api'
import {
  BCard, BRow, BCol, BFormInput, BTable, BMedia, BBadge, BPagination, BSpinner, BButtonToolbar, BButtonGroup, VBTooltip, BButton,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import store from '@/store'
import config from '@/services/config'
import { formatDateTime } from '@/helpers/dates'
import Ripple from 'vue-ripple-directive'
import { useNotify } from '@/helpers/toast'

export default {
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    /* BButton, */
    BTable,
    BMedia,
    BBadge,
    BPagination,
    BSpinner,

    vSelect,
    flatPickr,
    BButtonToolbar,
    BButtonGroup,
    BButton,
  },
  setup(_, context) {
    const { notify } = useNotify(context)
    const isBusy = ref(false)
    const items = ref([])
    const fields = ref([
      { key: 'idFrmContacto', sortable: true, thClass: 'd-none', tdClass: 'd-none' },
      { key: 'nombres', label: 'Usuario', sortable: true },
      { key: 'email', label: 'Contacto', sortable: true },
      { key: 'asunto', label: 'Mensaje', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
      { key: 'fechaRegistro', label: 'Fechas', sortable: true, thClass: 'text-center', tdClass: 'text-justify' },
      { key: 'estadoAtencion', label: 'Estado', sortable: true, thClass: 'text-center', tdClass: 'text-justify' },
      { key: 'acciones', thClass: 'text-center', tdClass: 'text-center' },
    ])
    const configDP = ref({
      enableTime: false,
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'd/m/Y',
    })
    const page = ref(1)
    const perPage = ref(10)
    const sortBy = ref('idFrmContacto%7CDESC')
    const query = ref('')
    const fechaFilter = ref('')
    const totalRows = ref(0)
    const totalItems = ref(0)
    const totalPage = ref(0)
    const from = ref(0)
    const to = ref(0)
    const of = ref(0)
    const pageOptions = ref([10, 20, 50])
    const { baseURL } = config

    const listarRegistros = async () => {
      isBusy.value = true
      await store.dispatch('portal/FRM_CONTACTO_FIND_ALL', {
        tipo: 'grilla',
        query: query.value,
        page: page.value,
        limit: perPage.value,
        sortBy: sortBy.value,
        dateFilter: fechaFilter.value,
      })
        .then(response => {
          if (response) {
            items.value = response.items
            totalRows.value = response.totalRows
            totalItems.value = response.totalItems
            totalPage.value = response.totalPage
            from.value = perPage.value * (page.value - 1) + (totalRows.value ? 1 : 0)
            to.value = perPage.value * (page.value - 1) + totalRows.value
            of.value = totalItems.value
          }
        })
      isBusy.value = false
    }

    const updateStatus = data => {
      console.log('aca estamos >', data)
      Vue.swal({
        title: 'Está seguro?',
        text: 'Va actualizar el estatus a ATENDIDO!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store
            .dispatch('portal/FRM_CONTACTO_UPDATE_STATUS', {
              id: data.idFrmContacto,
            })
            .then(() => {
              notify('Operación Exitosa', 'Ha actualizado el estado correctamente.', 'success')
              listarRegistros()
            })
            .catch(error => {
              let errorMessage = 'Intentelo en otro momento.'
              if (error.response) {
                errorMessage = error.response.data.message
              }
              notify('Ha ocurrido un error', errorMessage, 'danger')
            })
        }
      })
    }

    watch([page, perPage, query, fechaFilter], () => {
      listarRegistros()
    })

    listarRegistros()

    return {
      avatarText,
      isBusy,
      sortBy,
      page,
      perPage,
      query,
      items,
      fields,
      fechaFilter,
      listarRegistros,
      totalRows,
      totalItems,
      totalPage,
      from,
      to,
      of,
      pageOptions,
      configDP,
      baseURL,
      formatDateTime,
      updateStatus,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
